module.exports = __webpack_public_path__ + "static/media/spec_meds.12372bbc.png";